import React, { useContext, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { Store } from "../Store";
import { Link, useNavigate } from "react-router-dom";
import classes from "../Assets/Styles/Signin.module.css";
import { ToastContainer, toast } from "react-toastify";
import { resetPassword as requestPasswordReset } from "../features/auth/api";
import { golobalFont, labelColors } from "../utils/constants";

const ForgotPasswordScreen = () => {
  const emailInputId = "forgot-password-email";
  const emailInstructionsId = "forgot-password-email-instructions";
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;

  const resetPassword = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error("Please enter your email");
      return;
    }

    try {
      setIsLoading(true);

      const { data } = await requestPasswordReset({
        email,
      });

      toast.success(
        data?.message || "Password reset instructions were sent to your email"
      );

      setEmail("");
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Failed to send password reset email"
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    ctxDispatch({ type: "PROJECT_FILE_CLEAR" });

    if (userInfo) {
      if (userInfo.isAdmin) navigate("/adminlanding");
      else navigate("/landing");
    }
  }, [ctxDispatch, navigate, userInfo]);

  return (
    <Grid
      item
      container
      direction="column"
      alignItems="center"
      marginTop={20}
      marginBottom={21.9}
    >
      <ToastContainer position="top-center" color="yellow" />

      <Grid
        item
        container
        justifyContent="center"
        width="40%"
        className={classes["HomeCardDetails"]}
      >
        <form onSubmit={resetPassword}>
          <Grid item container direction="column">
            <Grid item container color="white" justifyContent="center">
              <Grid item className={classes["header"]}>
                Forgot Password
              </Grid>
            </Grid>

            <Grid item marginTop={1.5} marginBottom={2}>
              <div
                id={emailInstructionsId}
                style={{
                  color: `${labelColors}`,
                  fontFamily: `${golobalFont}`,
                  textAlign: "center",
                }}
              >
                Enter your email and we will send you password reset instructions.
              </div>
            </Grid>

            <Grid item fontSize="var(--font-size-header)" marginBottom={1.5}>
              <label htmlFor={emailInputId}>
                <div className={classes["labels"]}>Email</div>
              </label>
            </Grid>

            <input
              id={emailInputId}
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              aria-describedby={emailInstructionsId}
              className={classes["SampleInputForm"]}
            />

            <Grid item marginLeft={5} marginTop={1.5}>
              <Link
                to="/"
                style={{
                  textDecoration: "none",
                  color: `${labelColors}`,
                  fontFamily: `${golobalFont}`,
                }}
              >
                <span>Remember your password? Login</span>
              </Link>
            </Grid>

            <Grid item marginLeft={5} marginTop={1.5}>
              <Link
                to="/signup"
                style={{
                  textDecoration: "none",
                  color: `${labelColors}`,
                  fontFamily: `${golobalFont}`,
                }}
              >
                <span>You don't have an account? Sign up</span>
              </Link>
            </Grid>
          </Grid>

          <Grid
            item
            container
            direction="column"
            alignItems="center"
            marginTop={3.5}
            marginBottom={4}
          >
            <button
                type="submit"
                disabled={isLoading}
                className={classes["SampleActiveButton"]}
                style={{
                    minWidth: "170px",
                    whiteSpace: "nowrap",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                }}
            >
                {isLoading ? "Sending..." : "Reset Password"}
            </button>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};

export default ForgotPasswordScreen;
